(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class BwPredictiveSearch extends HTMLElement {
    constructor() {
      super();
      this.input = null;
      this.results = null;
      this.debounceTimer = null;
      this.activeIndex = -1;
      this.items = [];
    }

    connectedCallback() {
      this.input = this.querySelector('.bw-search-bar__input');
      this.results = this.querySelector('.bw-search-results');
      if (!this.input || !this.results) return;

      this.input.addEventListener('input', this.onInput.bind(this));
      this.input.addEventListener('keydown', this.onKeydown.bind(this));
      this.input.addEventListener('focus', () => {
        if (this.input.value.trim().length >= 2) this.fetchResults(this.input.value.trim());
      });

      document.addEventListener('click', (e) => {
        if (!this.contains(e.target)) this.closeResults();
      });
    }

    onInput(e) {
      clearTimeout(this.debounceTimer);
      const query = e.target.value.trim();
      if (query.length < 2) { this.closeResults(); return; }
      this.debounceTimer = setTimeout(() => this.fetchResults(query), 200);
    }

    onKeydown(e) {
      if (this.results.hidden) return;
      if (e.key === 'ArrowDown') {
        e.preventDefault();
        this.activeIndex = Math.min(this.activeIndex + 1, this.items.length - 1);
        this.updateActive();
      } else if (e.key === 'ArrowUp') {
        e.preventDefault();
        this.activeIndex = Math.max(this.activeIndex - 1, -1);
        this.updateActive();
      } else if (e.key === 'Enter' && this.activeIndex >= 0) {
        e.preventDefault();
        this.items[this.activeIndex]?.click();
      } else if (e.key === 'Escape') {
        this.closeResults();
        this.input.blur();
      }
    }

    updateActive() {
      this.items.forEach((item, i) => {
        item.classList.toggle('bw-search-results__item--active', i === this.activeIndex);
      });
    }

    async fetchResults(query) {
      this.showStatus('Searching\u2026');
      try {
        const url = `/search/suggest.json?q=${encodeURIComponent(query)}&resources[type]=product&resources[limit]=6&resources[options][unavailable_products]=last`;
        const res = await fetch(url);
        if (!res.ok) throw new Error();
        const data = await res.json();
        this.renderResults(data.resources.results.products || []);
      } catch (_) {
        this.closeResults();
      }
    }

    formatPrice(priceCents) {
      if (typeof Shopify !== 'undefined' && typeof Shopify.formatMoney === 'function') {
        return Shopify.formatMoney(priceCents, Shopify.money_format || '\u00a3{{amount}}');
      }
      return '\u00a3' + (priceCents / 100).toFixed(2);
    }

    renderResults(products) {
      this.activeIndex = -1;
      if (products.length === 0) {
        this.showStatus('No products found');
        this.items = [];
        return;
      }
      this.results.innerHTML = products.map(p => {
        const img = p.image
          ? `<img class="bw-search-results__img" src="${p.image}" alt="${this.esc(p.title)}" width="50" height="50" loading="lazy">`
          : `<div class="bw-search-results__img-placeholder"></div>`;
        const price = typeof p.price === 'number' ? this.formatPrice(p.price) : this.esc(String(p.price));
        return `<li role="option"><a href="${p.url}" class="bw-search-results__item">${img}<div class="bw-search-results__info"><div class="bw-search-results__title">${this.esc(p.title)}</div><div class="bw-search-results__price">${price}</div></div></a></li>`;
      }).join('');
      this.results.hidden = false;
      this.input.setAttribute('aria-expanded', 'true');
      this.items = [...this.results.querySelectorAll('.bw-search-results__item')];
    }

    showStatus(msg) {
      this.results.innerHTML = `<li class="bw-search-results__status">${msg}</li>`;
      this.results.hidden = false;
      this.input.setAttribute('aria-expanded', 'true');
    }

    closeResults() {
      this.results.hidden = true;
      this.input.setAttribute('aria-expanded', 'false');
      this.activeIndex = -1;
      this.items = [];
    }

    esc(str) {
      const d = document.createElement('div');
      d.textContent = str;
      return d.innerHTML;
    }
  }

  customElements.define('bw-predictive-search', BwPredictiveSearch);

  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
